import {RemoteModules} from 'app/interface';

import {GemSettings} from '../config/interface';
import {getRemotesConfiguration} from '../remotes/getRemotesConfiguration';
import {loadExposed} from '../remotes/loadExposed';

const GEM_REMOTE_ELEMENT_NAME = 'gem-remote';

function getRemoteGlobalName(remoteName: string | null): string {
    return `GEM_${remoteName}`;
}

export function defineRemotesLoader(gemSettings: GemSettings) {
    if (customElements.get(GEM_REMOTE_ELEMENT_NAME)) {
        return;
    }

    const remotesAlreadyLoaded = new Set<string>();
    class GemRemoteLoader extends HTMLElement {
        connectedCallback() {
            const remoteName = this.dataset.remoteName ?? null;
            const remoteEntryFilename = getRemotesConfiguration()?.[getRemoteGlobalName(remoteName)];
            if (!remoteEntryFilename || !remoteName || remotesAlreadyLoaded.has(remoteName)) {
                return;
            }
            remotesAlreadyLoaded.add(remoteName);

            const remoteFilePublicPath = `${gemSettings.assetsDomain ?? ''}/etc/designs/gem/themes/js/packages/${getRemoteGlobalName(
                remoteName,
            )}/${remoteEntryFilename}`;

            loadExposed<RemoteModules>(getRemoteGlobalName(remoteName), './defineWebComponents', remoteFilePublicPath)().then(({defineWebComponents}) => {
                defineWebComponents?.(gemSettings);
            });

            loadExposed<RemoteModules>(getRemoteGlobalName(remoteName), './init', remoteFilePublicPath)().then(({init}) => {
                init?.({gemSettings});
            });
        }
    }

    customElements.define(GEM_REMOTE_ELEMENT_NAME, GemRemoteLoader);
}

// Extend JSX to recognize custom elements
declare module 'react' {
    // eslint-disable-next-line @typescript-eslint/no-namespace
    namespace JSX {
        interface IntrinsicElements {
            'gem-remote': DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>;
        }
    }
}
